export const fileNameLength = 16
export const folderNameLength = 23
